<div class="info-message-container" [ngClass]="infoMessageModel.type">
    <span [ngClass]="infoMessageModel.type" mat-snack-bar-label>{{infoMessageModel.message}}</span>
    <span mat-snack-bar-actions>
        <i class="fa-solid fa-times cursor-pointer text-xl" mat-snack-bar-action (click)="snackBarRef.dismissWithAction()"></i>
    </span>
</div>
